import { Menu, Search } from 'lucide-react'
import { useSidebarUI } from '@/context/SidebarUIContext'
import { useSearchModal } from '@/context/SearchModalContext'
import { useAppSelector } from '@/store/hooks'
import { selectIsAuthenticated } from '@/store/slices/authSlice'
import { Input } from '@/components/ui/input'
import { AuthenticatedActions } from './AuthenticatedActions'
import { UnauthenticatedActions } from './UnauthenticatedActions'

export function Header() {
	const { openMobileSidebar } = useSidebarUI()
	const { open: openSearch } = useSearchModal()
	const isAuthenticated = useAppSelector(selectIsAuthenticated)

	return (
		<header className='sticky top-0 z-20 bg-background/95 backdrop-blur lg:static lg:bg-transparent lg:backdrop-blur-none'>
			<div className='flex min-w-0 flex-wrap items-center gap-2 px-4 py-3 sm:gap-3 sm:px-6 sm:py-4 lg:px-0'>
				<button
					type='button'
					onClick={openMobileSidebar}
					className='flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-border text-foreground sm:h-[50px] sm:w-[50px] lg:hidden'
					aria-label='Open sidebar'
				>
					<Menu className='h-5 w-5' />
				</button>

				<div className='order-3 w-full min-w-0 basis-full sm:order-none sm:w-auto sm:max-w-[369px] sm:flex-1'>
					<button type='button' onClick={openSearch} className='w-full text-left' aria-label='Open game search'>
						<Input variant='icon' icon={<Search />} type='text' placeholder='Search' readOnly tabIndex={-1} className='pointer-events-none' />
					</button>
				</div>

				<div className='order-2 ml-auto flex shrink-0 items-center gap-2 sm:order-none sm:gap-3'>
					{isAuthenticated ? <AuthenticatedActions /> : <UnauthenticatedActions />}
				</div>
			</div>
		</header>
	)
}
